import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { ButtonBase, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Forward } from '@material-ui/icons';
import { getRTLPopperStyles } from '~/modules/common/util';
import { useBulkProposeAllocationsForResourceRequest } from '~/modules/resourcing/common/hooks';
import useStyles from './useStyles';

const useTooltipPopperStyles = makeStyles(theme => ({
  popper: () => ({
    ...getRTLPopperStyles({ theme }),
    display: 'flex'
  })
}));

export const ResourceMatchItemProposeButton = ({
  dataQeId,
  resourceRequest
}) => {
  const classes = useStyles();
  const tooltipPopperClasses = useTooltipPopperStyles();
  const { formatMessage } = useIntl();
  const { resourceMatches } = resourceRequest;
  const [resourceMatch] = resourceMatches || [];
  const forwardDataQeId = dataQeId
    ? `${dataQeId}_ResourceMatchItemProposeButton`
    : undefined;
  const proposeTooltipTitle = formatMessage({
    id: 'resourceMatchItem.proposeResource'
  });

  const {
    bulkProposeAllocationsForResourceRequest
  } = useBulkProposeAllocationsForResourceRequest();

  const handlePropose = useCallback(
    _event => {
      bulkProposeAllocationsForResourceRequest({
        submittedResourceRequestsWithMatches: [
          {
            resourceRequest,
            userIds: resourceMatch ? [resourceMatch.userUri] : []
          }
        ]
      });
    },
    [bulkProposeAllocationsForResourceRequest, resourceRequest, resourceMatch]
  );

  return (
    <ButtonBase
      data-qe-id={forwardDataQeId}
      className={classes.itemButtonShadow}
      onClick={handlePropose}
    >
      <Tooltip
        title={proposeTooltipTitle}
        aria-label={proposeTooltipTitle}
        aria-hidden={false}
        placement="bottom-start"
        classes={tooltipPopperClasses}
      >
        <Forward className={classes.itemButtonIcon} />
      </Tooltip>
    </ButtonBase>
  );
};

ResourceMatchItemProposeButton.propTypes = {
  dataQeId: PropTypes.string,
  resourceRequest: PropTypes.object.isRequired
};

export default ResourceMatchItemProposeButton;
